import {
  ProjectCreationRequest,
  ProjectsApi,
} from 'osep-generator-service-client-v1';
import { useApiConfig } from '../useApiConfig';

function useCreateProductsMutation() {
  const { getApiConfig, axiosInstance } = useApiConfig();

  const createProduct = async (project: ProjectCreationRequest) => {
    const config = await getApiConfig();
    const projectsApi = new ProjectsApi(config, undefined, axiosInstance);

    const response = await projectsApi.createProject(project);

    return response.data;
  };

  return { createProduct };
}

export default useCreateProductsMutation;
